import api from "./client";

export async function fetchBackendVersion() {
  const response = await api.get("/api/version");
  return response.data?.version ?? "unknown";
}
